"use client";
import { useState, useEffect } from "react";
import Image from "next/image";
import { Button } from "flowbite-react";
import { FaMapMarkerAlt, FaEnvelope, FaPhone } from 'react-icons/fa';


const Intro = () => {
    return (
        <div>
            <section className=" bg-white py-10 md:py-20 lg:py-24">
                <div className="max-w-screen-xl mx-5 lg:mx-auto">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 items-start justify-between text-center mb-6 md:mb-10">
                        <div>
                            <a href="/gallery/"><img src="/images/an_gallery1.jpg" className="object-cover w-fit rounded-lg shadow-lg" alt="" /></a>
                        </div>
                        <div>
                            <a href="/gallery/"><img src="/images/an_gallery2.jpg" className="object-cover w-fit rounded-lg shadow-lg" alt="" /></a>
                        </div>
                        <div>
                            <a href="/gallery/"><img src="/images/an_gallery3.jpg" className="object-cover w-fit rounded-lg shadow-lg" alt="" /></a>
                        </div>
                        <div>
                            <a href="/gallery/"><img src="/images/an_gallery4.jpg" className="object-cover w-fit rounded-lg shadow-lg" alt="" /></a>
                        </div>
                        <div>
                            <a href="/gallery/"><img src="/images/fm_gallery8.jpg" className="object-cover w-fit rounded-lg shadow-lg" alt="" /></a>
                        </div>
                    </div>
                    <div className="grid grid-cols-1 gap-3 md:gap-6 items-start justify-between">
                        <p className="font-bold">3POP Studios</p>
                        <p className="font-bold mb-0">Welcome to 3Pop Studios!</p>
                        <p>We are a full service animation production company delivering its expertise in 2D & 3D Animation, Design & VFX to clients locally and internationally.<br />
                        We treat each project with equal amount of passion & pop and it’s our constant endeavour to push the boundaries, in a bid to achieve super high standards of quality.<br />
                        We are always eager to explore ways of creating content through newer technologies. It’s the actual ‘process’ that excites us and not just the 'end' product.</p>
                        <p className="font-bold mb-0">Our Services:</p>
                        <ul className="list-disc ml-4 mb-4">
                            <li>2D Animation</li>
                            <li>3D Animation</li>
                            <li>Character Design and Model Sheets</li>
                            <li>Story Boarding &amp; Animatics</li>
                            <li>Modeling</li>
                            <li>Texturing and Shading</li>
                            <li>Rigging</li>
                            <li>Lighting</li>
                            <li>Visual Effects</li>
                            <li>Compositing</li>
                            <li>Rendering</li>
                        </ul>
                    </div>                    
                </div>
            </section>
        </div>
    );
};

export default Intro;